import RelatedLinks from 'components/ProductPage/RelatedLinks/RelatedLinks';

export default RelatedLinks;
